export const removeBlankFields = (value) => {
  return Object.fromEntries(Object.entries(value).filter((en) => en[1] || en[1] === 0));
};
